<h2 mat-dialog-title *ngIf="data.pageName !== undefined">{{this.pageName | translate}}</h2>
<vias-form #formApproval
[formItems]="formItems"
[numLocale]="numLocale"
(formItemClick)="formItemIconClickHandler($event)"
></vias-form>